<mat-form-field class="search-input">
    <i class="fas fa-search search-icon" matPrefix></i>
    <input class="searchTextField" matInput [placeholder]="inputPlaceholder" [(ngModel)]="searchTextField.value" #searchTextField  (keydown.enter)="onEnterPress(searchTextField.value)" (keyup)="search(searchTextField.value)"
        autocomplete="off" />
    <i class="fas fa-times cross-icon" (click)="searchTextField.value='';clearFilterSearch(); $event.stopPropagation();"
        *ngIf="searchTextField.value.length>0" aria-hidden="true" id="clearSearchIcon" matSuffix></i>
</mat-form-field>